module.exports = __webpack_public_path__ + "static/img/6.878cb43.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/sp/6.png
// module id = AQyR
// module chunks = 0